/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Action_ColInputs */

const en_admin_permissions_action_col = /** @type {(inputs: Admin_Permissions_Action_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const zh_admin_permissions_action_col = /** @type {(inputs: Admin_Permissions_Action_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Admin_Permissions_Action_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_action_col = /** @type {((inputs?: Admin_Permissions_Action_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Action_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_action_col(inputs)
	return zh_admin_permissions_action_col(inputs)
});
export { admin_permissions_action_col as "admin.permissions.action_col" }